import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.m5y_1 = call;
        this.n5y_1 = data.j5m_1;
        this.o5y_1 = data.i5m_1;
        this.p5y_1 = data.l5m_1;
        this.q5y_1 = data.k5m_1;
        this.r5y_1 = data.n5m_1;
      }
      v5j() {
        return this.m5y_1;
      }
      sv() {
        return this.v5j().sv();
      }
      w5j() {
        return this.n5y_1;
      }
      x5j() {
        return this.o5y_1;
      }
      h2o() {
        return this.p5y_1;
      }
      n51() {
        return this.q5y_1;
      }
      p5j() {
        return this.r5y_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
